import { render, staticRenderFns } from "./BaseCardRow.vue?vue&type=template&id=7044e6d8&scoped=true"
import script from "./BaseCardRow.vue?vue&type=script&lang=js"
export * from "./BaseCardRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7044e6d8",
  null
  
)

export default component.exports